import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-white border-t border-gray-200 py-12 mt-20">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="font-serif text-xl text-brand-green-800 mb-4">Healing with Hailey</h3>
            <p className="text-gray-600 text-sm">
              Holistic nutrition and wellness guidance for your unique healing journey.
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold text-gray-900 mb-4">Services</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/personalized" className="text-gray-600 hover:text-brand-green-600">1:1 Consultations</a></li>
              <li><a href="/community" className="text-gray-600 hover:text-brand-green-600">Group Sessions</a></li>
              <li><a href="/catalog" className="text-gray-600 hover:text-brand-green-600">Resources</a></li>
              <li><a href="/intake" className="text-gray-600 hover:text-brand-green-600">Intake Form</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold text-gray-900 mb-4">Client Access</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/client" className="text-gray-600 hover:text-brand-green-600">Client Portal</a></li>
              <li><a href="/admin" className="text-gray-600 hover:text-brand-green-600">Admin Login</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold text-gray-900 mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/legal/privacy" className="text-gray-600 hover:text-brand-green-600">Privacy Policy</a></li>
              <li><a href="/legal/terms" className="text-gray-600 hover:text-brand-green-600">Terms of Service</a></li>
              <li><a href="/legal/health-privacy" className="text-gray-600 hover:text-brand-green-600">Health Privacy</a></li>
              <li><a href="/legal/user-guide" className="text-gray-600 hover:text-brand-green-600">User Guide</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t pt-8 text-center text-sm text-gray-500">
          <p>&copy; {new Date().getFullYear()} Healing with Hailey. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};